/*
 * PIKA — výběr velikosti před přidáním do košíku (1. 10. 2026, konverze).
 *
 * Nic se nepředvybírá (nejmenší velikost, tj. EU30 / EU36, dělala „duchy“ v košíku). Stav „bez výběru“ značí
 * atribut `data-pika-bez-velikosti` na formuláři produktu:
 *   - stránka produktu: nastaví ho pika-size-grid (Liquid pozná, že v adrese není ?variant=),
 *   - rychlý nákup v kolekci: nastaví ho tento soubor po načtení obsahu zásuvky (značka [data-pika-bez-qb]).
 * Dokud je atribut na formuláři, „Přidat do košíku“ nic nepřidá, zvýrazní mřížku velikostí a ukáže hlášku.
 * Výběr velikosti stav ukončí (PDP: pika-size-grid, rychlý nákup: událost change níž).
 */
(function () {
  'use strict';
  if (window.__pikaVyberVelikosti) return;
  window.__pikaVyberVelikosti = true;

  var I18N = window.PIKA_I18N || {};
  var TXT = I18N['pikastore.w.size_grid.select_size_hint'] || '';
  var ATTR = 'data-pika-bez-velikosti';

  function jeBez(f) { return !!(f && f.getAttribute && f.hasAttribute(ATTR)); }

  /* Oblast s velikostmi k formuláři: na PDP vlastní mřížka, v rychlém nákupu fieldset tématu. */
  function oblast(form) {
    var fid = form && form.getAttribute && form.getAttribute('id');
    var pdp = document.querySelector('[data-pika-size-wrapper]');
    if (pdp && !(pdp.closest && pdp.closest('quick-buy-drawer'))) {
      var gf = fid && String(fid).indexOf('quick-buy-form') === 0;
      if (!gf) return pdp;
    }
    var root = fid ? document.querySelector('product-rerender[observe-form="' + fid + '"]') : null;
    return root ? root.querySelector('.variant-picker__option') : null;
  }

  function hlaska(area) {
    var h = area.querySelector('[data-pika-vyber-hlaska]');
    if (!h) {
      h = document.createElement('div');
      h.className = 'pika-vyber-hlaska';
      h.setAttribute('data-pika-vyber-hlaska', '');
      h.setAttribute('role', 'alert');
      var kam = area.querySelector('[data-pika-size-grid], .variant-picker__option-values');
      if (kam && kam.parentNode) kam.parentNode.insertBefore(h, kam); else area.appendChild(h);
    }
    return h;
  }

  function vyzva(form) {
    var area = oblast(form);
    if (!area) return;
    var h = hlaska(area);
    h.textContent = TXT;
    h.hidden = false;
    area.classList.remove('pika-vyzva');
    void area.offsetWidth; /* restart animace při opakovaném kliknutí */
    area.classList.add('pika-vyzva');
    setTimeout(function () { area.classList.remove('pika-vyzva'); }, 1100);
    var r = area.getBoundingClientRect();
    if (r.top < 70 || r.bottom > (window.innerHeight || 800) - 24) {
      var klidny = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { area.scrollIntoView({ block: 'center', behavior: klidny ? 'auto' : 'smooth' }); } catch (e) { area.scrollIntoView(); }
    }
    try { document.dispatchEvent(new CustomEvent('pika:vyber-velikosti', { detail: { form: form } })); } catch (e) {}
  }

  function zadrz(e, form) {
    e.preventDefault();
    e.stopImmediatePropagation();
    vyzva(form);
  }

  /* Zachytávací fáze na document: dřív než téma (ProductForm.submit) i než cokoli, co poslouchá na tlačítku. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t && t.closest ? t.closest('button, input[type="submit"]') : null;
    if (!b || b.type !== 'submit') return;
    var f = b.form;
    if (jeBez(f)) zadrz(e, f);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (jeBez(f)) zadrz(e, f);
  }, true);

  /* ---- rychlý nákup (zásuvka na kartě): obsah se dotahuje až po otevření ---- */
  function zpracujQB(drawer) {
    var m = drawer.querySelector('[data-pika-bez-qb]:not([data-hotovo])');
    if (!m) return;
    m.setAttribute('data-hotovo', '1');
    var fid = m.getAttribute('data-form');
    var form = fid ? document.getElementById(fid) : null;
    if (!form || form.tagName !== 'FORM') return;
    form.setAttribute(ATTR, '');
    var ins = form.elements ? Array.prototype.slice.call(form.elements) : [];
    ins.forEach(function (i) {
      if (i.matches && i.matches('input[data-option-position]:checked')) i.checked = false;
    });
    var root = drawer.querySelector('product-rerender[observe-form="' + fid + '"]') || drawer;
    var val = root.querySelector('.variant-picker__option-info .h-stack > span');
    if (val) { val.textContent = ''; val.setAttribute('data-pika-hint', TXT); }
  }
  function sleduj(drawer) {
    if (!drawer || drawer.__pikaVyber) return;
    drawer.__pikaVyber = true;
    new MutationObserver(function () { zpracujQB(drawer); }).observe(drawer, { childList: true, subtree: true });
    zpracujQB(drawer);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var c = t && t.closest ? t.closest('[aria-controls^="quick-buy-"]') : null;
    if (c) sleduj(document.getElementById(c.getAttribute('aria-controls')));
  }, true);
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    var c = t && t.closest ? t.closest('[aria-controls^="quick-buy-"]') : null;
    if (c) sleduj(document.getElementById(c.getAttribute('aria-controls')));
  }, { passive: true, capture: true });

  /* Výběr velikosti v rychlém nákupu ukončí stav bez výběru (na PDP to dělá pika-size-grid). */
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.matches('input[data-option-position]')) return;
    var f = i.form;
    var fid = f && f.getAttribute('id');
    if (f && fid && String(fid).indexOf('quick-buy-form') === 0 && jeBez(f)) {
      f.removeAttribute(ATTR);
      var a = oblast(f);
      if (a) { var h = a.querySelector('[data-pika-vyber-hlaska]'); if (h) h.hidden = true; }
    }
  }, true);
})();
